/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_TitleInputs */

const en_event_group_options_title = /** @type {(inputs: Event_Group_Options_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event Group Options`)
};

const fr_event_group_options_title = /** @type {(inputs: Event_Group_Options_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Options du groupe d'événements`)
};

const de_event_group_options_title = /** @type {(inputs: Event_Group_Options_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optionen für Veranstaltungsgruppen`)
};

const it_event_group_options_title = /** @type {(inputs: Event_Group_Options_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opzioni gruppo evento`)
};

const ru_event_group_options_title = /** @type {(inputs: Event_Group_Options_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Параметры группы событий`)
};

const es_event_group_options_title = /** @type {(inputs: Event_Group_Options_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opciones de grupo de eventos`)
};

const zh_cn2_event_group_options_title = /** @type {(inputs: Event_Group_Options_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件组选项`)
};

const ja_event_group_options_title = /** @type {(inputs: Event_Group_Options_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントグループオプション`)
};

const hi_event_group_options_title = /** @type {(inputs: Event_Group_Options_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट समूह विकल्प`)
};

const pt_pt2_event_group_options_title = /** @type {(inputs: Event_Group_Options_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opções de grupo de eventos`)
};

/**
* | output |
* | --- |
* | "Event Group Options" |
*
* @param {Event_Group_Options_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_title = /** @type {((inputs?: Event_Group_Options_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_options_title(inputs)
	if (locale === "de") return de_event_group_options_title(inputs)
	if (locale === "it") return it_event_group_options_title(inputs)
	if (locale === "ru") return ru_event_group_options_title(inputs)
	if (locale === "es") return es_event_group_options_title(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_options_title(inputs)
	if (locale === "ja") return ja_event_group_options_title(inputs)
	if (locale === "hi") return hi_event_group_options_title(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_options_title(inputs)
	return en_event_group_options_title(inputs)
});